import { render } from "./AddressSelectorRefactored.vue?vue&type=template&id=6643c9d9&scoped=true&ts=true"
import script from "./AddressSelectorRefactored.vue?vue&type=script&lang=ts"
export * from "./AddressSelectorRefactored.vue?vue&type=script&lang=ts"

import "./AddressSelectorRefactored.vue?vue&type=style&index=0&id=6643c9d9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6643c9d9"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QTooltip});
